import { Blockchain } from "@anaconda/core/blockchain/types"
import type { Nft } from "@anaconda/core/nft/types"
import { isItemBidSupportedNftStandard } from "@rarible_int/anaconda_sdk/solana"

export interface ItemOfferChainSupport {
  isEvm: boolean
  hasWrappedCurrency: boolean
}

/**
 * Solana: only the standards whose bids `fill_order_v2` can settle. A WNS or
 * compressed-NFT item bid can be created on-chain but never accepted, so the
 * offer would strand the bidder's escrowed SOL — hide the entry point rather
 * than disable it. An item whose `nftStandard` has not been indexed yet is
 * treated as unsupported for the same reason.
 *
 * EVM: a Rarible V2 bid paid in the chain's wrapped currency, which the owner
 * can only accept with an ERC721 — there is no ERC1155 accept path.
 */
export function canMakeItemOffer(
  nft: Nft,
  { isEvm, hasWrappedCurrency }: ItemOfferChainSupport,
): boolean {
  if (nft.collection.blockchain === Blockchain.SOLANA) {
    return isItemBidSupportedNftStandard(nft.nftStandard)
  }

  return isEvm && hasWrappedCurrency && nft.collection.type === "ERC721"
}
